import { FastpassOrderStatus } from '@hooks-api/types/dataModel/fpOrder'
import { useTranslation } from 'react-i18next'

export const useOrderPurchaseMessage = (status: FastpassOrderStatus | unknown) => {
  const { t } = useTranslation()

  if (status === FastpassOrderStatus.CANCELED || status === FastpassOrderStatus.REFUNDED) {
    return t('order.status.cancelled')
  }

  if (status === FastpassOrderStatus.PENDING) {
    return t('order.status.unpaid')
  }

  if (status === FastpassOrderStatus.COMPLETED) {
    return t('order.status.paid')
  }

  if (status === FastpassOrderStatus.FAILED) {
    return '付款失敗'
  }

  return '異常'
}
